module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-Medium.c520756.woff";